var map = {
	"./18_PW.png": 41257,
	"./19_PW.png": 1428,
	"./20PW.png": 87647,
	"./21PW.png": 35587,
	"components/Catalog/PW/img/glass/z/zPlusGold/18_PW.png": 41257,
	"components/Catalog/PW/img/glass/z/zPlusGold/19_PW.png": 1428,
	"components/Catalog/PW/img/glass/z/zPlusGold/20PW.png": 87647,
	"components/Catalog/PW/img/glass/z/zPlusGold/21PW.png": 35587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91321;